
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { LinkAccountSelect } from "./LinkAccountSelect";
import { LinkAccountSigning } from "./LinkAccountSigning";
import { LinkAccountStore } from "./LinkAccountStore";
import { LinkAccountSuccess } from "./LinkAccountSuccess";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class LinkAccountContainer extends React.Component<IProps, {}> {
    store: LinkAccountStore;

    constructor(props: any) {
        super(props);
        this.store = new LinkAccountStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized && this.props.externalInterfaceStore.currentCardId) {
                await this.store.load(this.props.externalInterfaceStore.currentCardId);
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("linkAccount.document.title");

        return (
            <div>
                <Route exact path={this.props.match.path} render={this.withStore(LinkAccountSelect)} />
                <Route path={this.props.match.path + "/signing"} render={this.withStore(LinkAccountSigning)} />
                <Route path={this.props.match.path + "/success"} render={this.withStore(LinkAccountSuccess)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/linkAccount/LinkAccountContainer.tsx